import { createAction } from '@reduxjs/toolkit';

import { withPayloadType } from 'utils';

export const showInvitationStart = createAction(
  'SHOW_INVITATION::START',
  withPayloadType<{ id: string; organizationId: string }>(),
);
